<div class="header">
  <span class="copy">Explore powerful new features</span>
  <ts-link-button
    text="Hide"
    (clickFn)="onHideClick()"
  ></ts-link-button>
</div>
<app-carousel-main
  [numItems]="0"
  [itemGap]="16"
  [showArrowBackground]="false"
  [arrowColorDark]="true"
  [persistentArrowBackground]="true"
  arrowWrapperWidth="72px"
  arrowSize="32px"
  (interact)="onCarouselInteract()"
  [showGradient]="true"
  [itemOffset]="24"
>
  @for (newFeature of newFeatures; track newFeature.featureId) {
    <div
      class="item-wrapper"
      *appCarouselItem
    >
      <div
        class="feature-container"
        (click)="onNewFeatureClick(newFeature)"
      >
        <div class="left">
          <div class="copy-container">
            <div class="header-container">
              @if (newFeature.carouselContent.isNew) {
                <ts-badge
                  color="primary"
                  text="NEW"
                  size="xs"
                ></ts-badge>
              }
              <span class="header-copy">{{ newFeature.carouselContent.headerText }}</span>
              <mat-icon svgIcon="chevron_right"></mat-icon>
            </div>
            <span class="copy">{{ newFeature.carouselContent.bodyText }} </span>
          </div>
        </div>
        <div class="right">
          <img
            [src]="newFeature.carouselContent.imageUrl"
            imgErrLog
          />
        </div>
      </div>
    </div>
  }
</app-carousel-main>
